/**
 * Created by roman.kupin on 10/3/2017.
 */

import * as BigPictureActions from "../actions/index";
import * as PropertyApiActions from "../../../../../actions/propertyApi";
import * as AdvocacyImpactApiActions from "../../../../../actions/advocacyImpactApi";

export default function bigPictureReducer(state = {
    isInitialized: false,
    startDate: null,
    endDate: null,
    layerInfoRequestStatus: null
}, {type, payload}) {

    switch (type) {
        case BigPictureActions.INITIALIZED: {
            return Object.assign({}, state, {isInitialized: payload});
        }
        case BigPictureActions.DATE_RANGE_CHANGE: {
            return Object.assign({}, state, {startDate: payload.startDate, endDate: payload.endDate});
        }
        case PropertyApiActions.ADVOCACY_OVERVIEW_FETCH_SUCCESS: {
            if(!payload.activeLayers) return state;
            const layerInfoRequestStatus = payload.activeLayers.map(l => {return {isLoaded: false, name: l.name}});
            return Object.assign({}, {layerInfoRequestStatus});
        }
        case AdvocacyImpactApiActions.LAYER_PRESTAY_STORIES_FETCH_SUCCESS: {
            const requestStatus = state.layerInfoRequestStatus.find(l => l.name === "Pre-Stay");
            if(!!requestStatus) {
                requestStatus.isLoaded = true;
                return Object.assign({}, state);
            }
            return state;
        }
        case AdvocacyImpactApiActions.LAYER_POSTSTAY_STORIES_FETCH_SUCCESS: {
            const requestStatus = state.layerInfoRequestStatus.find(l => l.name === "Post-Stay");
            if(!!requestStatus) {
                requestStatus.isLoaded = true;
                return Object.assign({}, state);
            }
            return state;
        }
        case AdvocacyImpactApiActions.LAYER_HOMEPAGE_STORIES_FETCH_SUCCESS: {
            const requestStatus = state.layerInfoRequestStatus.find(l => l.name === "Homepage");
            if(!!requestStatus) {
                requestStatus.isLoaded = true;
                return Object.assign({}, state);
            }
            return state;
        }
        case AdvocacyImpactApiActions.LAYER_QUOTELIST_STORIES_FETCH_SUCCESS: {
            const requestStatus = state.layerInfoRequestStatus.find(l => l.name === "Quote-List");
            if(!!requestStatus) {
                requestStatus.isLoaded = true;
                return Object.assign({}, state);
            }
            return state;
        }
        case AdvocacyImpactApiActions.LAYER_PHOTOCONTEST_STORIES_FETCH_SUCCESS: {
            const requestStatus = state.layerInfoRequestStatus.find(l => l.name === "Photo Contest");
            if(!!requestStatus) {
                requestStatus.isLoaded = true;
                return Object.assign({}, state);
            }
            return state;
        }
        default: {
            return state;
        }
    }
}